import React from "react";

import FormLabel from '@material-ui/core/FormLabel';

function LegendFormLabel (props) {
  const {
    ...other
  } = props;

  return (
    <FormLabel component="legend" {...other} />
  );
}

export default LegendFormLabel;
